import { createFileRoute } from "@tanstack/react-router";
import AISettings from "@/components/settings/ai-settings";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/settings/_layout/ai")({
  component: AISettingsPage,
});

function AISettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "ai_settings", actions: ["read", "update"] }]}
    >
      <AISettings />
    </RouteGuardPermissions>
  );
}
